import React, { useEffect, useState } from 'react';
import { Row, Col, message, Pagination } from 'antd';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';

import * as S from './styles';
import ActiveInvestigationsRow from '../../shared/StudentDashboardRows/ActiveInvestigationsRow';
import ActiveAssessmentsRow from '../../shared/StudentDashboardRows/ActiveAssessmentsRow';
import FinishedInvestigationsRow from '../../shared/StudentDashboardRows/FinishedInvestigationsRow';
import FinishedAssessmentsRow from '../../shared/StudentDashboardRows/FinishedAssessmentsRow';
import { gqlSchema } from '../../gql/schema';
import { DASHBOARD_TYPES, GQL_InvestigationDashboard } from '../../types/investigation';
import ClassesRow from '../../shared/StudentDashboardRows/ClassesRow';
import TeacherAnnouncementsRow from '../../shared/StudentDashboardRows/TeacherAnnouncementsRow';
//import { finishedInvestigationFilter, finishedAssessmentFilter } from '../../utils/investigation';

const StudentDashboard = () => {
  const { pathname, hash, key } = useLocation();
  const [pageActiveInv, setPageActiveInv] = useState(1);
  const [pageFinishedInv, setPageFinishedInv] = useState(1);
  const [pageActiveAssess, setPageActiveAssess] = useState(1);
  const [pageFinishedAssess, setPageFinishedAssess] = useState(1);
  const pageSize = 3;

  const { data: activeInvestigations, loading, error } = useQuery<{
    getInvestigationsByStudentUser: GQL_InvestigationDashboard[];
  }>(gqlSchema.InvestigationSchema.queries.DASHBOARD.getInvestigationsByStudentUser, {
    variables: { filter: { page: pageActiveInv, pageSize, type: DASHBOARD_TYPES.ACTIVE_INVESTIGATIONS } },
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your investigations. Check your connection and try again later.',
      );
    },
    fetchPolicy: 'cache-and-network',
  });
  const { data: activeAssessments } = useQuery<{
    getInvestigationsByStudentUser: GQL_InvestigationDashboard[];
  }>(gqlSchema.InvestigationSchema.queries.DASHBOARD.getInvestigationsByStudentUser, {
    variables: { filter: { page: pageActiveAssess, pageSize, type: DASHBOARD_TYPES.ACTIVE_ASSESSMENTS } },
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your investigations. Check your connection and try again later.',
      );
    },
    fetchPolicy: 'cache-and-network',
  });

  const { data: finishedInvestigations } = useQuery<{
    getInvestigationsByStudentUser: GQL_InvestigationDashboard[];
  }>(gqlSchema.InvestigationSchema.queries.DASHBOARD.getInvestigationsByStudentUser, {
    variables: { filter: { page: pageFinishedInv, pageSize, type: DASHBOARD_TYPES.FINISHED_INVESTIGATIONS } },
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your investigations. Check your connection and try again later.',
      );
    },
    fetchPolicy: 'cache-and-network',
  });

  const { data: finishedAssessments } = useQuery<{
    getInvestigationsByStudentUser: GQL_InvestigationDashboard[];
  }>(gqlSchema.InvestigationSchema.queries.DASHBOARD.getInvestigationsByStudentUser, {
    variables: { filter: { page: pageFinishedAssess, pageSize, type: DASHBOARD_TYPES.FINISHED_ASSESSMENTS } },
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your investigations. Check your connection and try again later.',
      );
    },
    fetchPolicy: 'cache-and-network',
  });




  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change

  // const activeInvestigations = useMemo(() => {
  //   return data?.getInvestigationsByStudentUser
  //     ?.filter((investigation) => !investigation.isAssessment)
  //     ?.filter((i) => !finishedInvestigationFilter(i));
  // }, [data]);

  // const activeAssessments = useMemo(() => {
  //   return data?.getInvestigationsByStudentUser
  //     ?.filter((investigation) => investigation.isAssessment)
  //     ?.filter((i) => !finishedAssessmentFilter(i));
  // }, [data]);

  // const finishedInvestigations = useMemo(() => {
  //   return data?.getInvestigationsByStudentUser
  //     ?.filter((investigation) => !investigation.isAssessment)
  //     ?.filter(finishedInvestigationFilter);
  // }, [data]);

  // const finishedAssessments = useMemo(() => {
  //   return data?.getInvestigationsByStudentUser
  //     ?.filter((investigation) => investigation.isAssessment)
  //     ?.filter(finishedAssessmentFilter);
  // }, [data]);

  const fetchInvestigations = useQuery<{
    getInvestigationsByStudentUser: GQL_InvestigationDashboard[];
  }>(gqlSchema.InvestigationSchema.queries.DASHBOARD.getInvestigationsByStudentUser, {
    skip: true, // Prevent automatic query execution on page load
    onError: (error) => {
      message.error(
        error.message || 'There was an error loading your investigations, check your connection and try again later.',
      );
    },
  });
  
  const handlePageChangeFinishedInv = async (newPage: number, type: DASHBOARD_TYPES) => {
    try {
      const { data } = await fetchInvestigations.refetch({
        filter: { page: newPage, pageSize, type },
      });
  
      const nextPageData = data?.getInvestigationsByStudentUser || [];
  
      if (nextPageData.length === 0) {
        message.info(`No more ${type} available, returning to the previous page.`);

        return;
      }
  
      // Update the correct page state based on type
      switch (type) {
        case DASHBOARD_TYPES.ACTIVE_INVESTIGATIONS:
          setPageActiveInv(newPage);
          break;
        case DASHBOARD_TYPES.FINISHED_INVESTIGATIONS:
          setPageFinishedInv(newPage);
          break;
        case DASHBOARD_TYPES.ACTIVE_ASSESSMENTS:
          setPageActiveAssess(newPage);
          break;
        case DASHBOARD_TYPES.FINISHED_ASSESSMENTS:
          setPageFinishedAssess(newPage);
          break;
        default:
          break;
      }
    } catch (error) {
      message.error('Failed to load data. Please try again.');
    }
  };
  

  const totalInvestigationsActiveInv = activeInvestigations?.getInvestigationsByStudentUser?.length || 0;
  const hasMorePagesActiveInv = totalInvestigationsActiveInv >= 3;

  const totalInvestigationsFinishedInv = finishedInvestigations?.getInvestigationsByStudentUser?.length || 0;
  const hasMorePagesFinishedInv = totalInvestigationsFinishedInv >= 3;

  const totalInvestigationsActiveAssessment = activeAssessments?.getInvestigationsByStudentUser?.length || 0;
  const hasMorePagesActiveAssessment = totalInvestigationsActiveAssessment >= 3;

  const totalInvestigationsFinishedAssessment = finishedAssessments?.getInvestigationsByStudentUser?.length || 0;
  const hasMorePagesFinishedAssessment = totalInvestigationsFinishedAssessment >= 3;



  return (
    <S.Container>
      <Row gutter={[24, 24]}>
        <Col xxl={{ span: 18, offset: 3 }} xl={24} lg={24} md={24} sm={24}>
          <TeacherAnnouncementsRow />
          <ClassesRow />

          <ActiveInvestigationsRow
            loading={loading}
            investigations={activeInvestigations?.getInvestigationsByStudentUser}
            error={error?.message}
          />
          <Pagination
            current={pageActiveInv}
            pageSize={pageSize}
            total={hasMorePagesActiveInv ? (pageActiveInv + 1) * pageSize : pageActiveInv * pageSize}
            onChange={(newPage) => handlePageChangeFinishedInv(newPage, DASHBOARD_TYPES.ACTIVE_INVESTIGATIONS)}
            showSizeChanger={false}
            hideOnSinglePage={totalInvestigationsActiveInv <= pageSize}
            style={{ textAlign: 'center', marginTop: 16 }}
            disabled={loading}
          />


          <ActiveAssessmentsRow
            loading={loading}
            assessments={activeAssessments?.getInvestigationsByStudentUser}
            error={error?.message}
          />
          <Pagination
            current={pageActiveAssess}
            pageSize={pageSize}
            total={hasMorePagesActiveAssessment ? (pageActiveAssess + 1) * pageSize : pageActiveAssess * pageSize}
            onChange={(newPage) => handlePageChangeFinishedInv(newPage, DASHBOARD_TYPES.ACTIVE_ASSESSMENTS)}
            showSizeChanger={false}
            hideOnSinglePage={totalInvestigationsActiveAssessment <= pageSize}
            style={{ textAlign: 'center', marginTop: 16 }}
            disabled={loading}
          />

          <FinishedInvestigationsRow
            loading={loading}
            investigations={finishedInvestigations?.getInvestigationsByStudentUser}
            error={error?.message}
          />
          <Pagination
            current={pageFinishedInv}
            pageSize={pageSize}
            total={hasMorePagesFinishedInv ? (pageFinishedInv + 1) * pageSize : pageFinishedInv * pageSize}
            onChange={(newPage) => handlePageChangeFinishedInv(newPage, DASHBOARD_TYPES.FINISHED_INVESTIGATIONS)}
            showSizeChanger={false}
            hideOnSinglePage={totalInvestigationsFinishedInv <= pageSize}
            style={{ textAlign: 'center', marginTop: 16 }}
            disabled={loading}
          />

          <div id="finished-assessments-row">
            <FinishedAssessmentsRow
              loading={loading}
              assessments={finishedAssessments?.getInvestigationsByStudentUser}
              error={error?.message}
            />
          </div>
          <Pagination
            current={pageFinishedAssess}
            pageSize={pageSize}
            total={hasMorePagesFinishedAssessment ? (pageFinishedAssess + 1) * pageSize : pageFinishedAssess * pageSize}
            onChange={(newPage) => handlePageChangeFinishedInv(newPage, DASHBOARD_TYPES.FINISHED_ASSESSMENTS)}
            showSizeChanger={false}
            hideOnSinglePage={totalInvestigationsFinishedAssessment <= pageSize}
            style={{ textAlign: 'center', marginTop: 16 }}
            disabled={loading}
          />

        </Col>
      </Row>
    </S.Container>
  );
};


export default StudentDashboard;
